<template>
  <div id="app">
    <section class="hero is-fullheight">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div>
              <a href="/">
                <p class="title">Hand and Brain Chess (beta)</p>
                <p class="subtitle">The <span class="bright">BRAIN</span> will highlight the pieces to move.
                You must play the correct move as the <span class="bright">HAND</span>. <br> <br><a @click.prevent="moreInfo=true"> Learn more about this project</a> or
                <a href="http://twitter.com/share?text=Play the Hand and Brain Chess variation online&amp;url=http://handandbrainchess.com&amp;hashtags=chess&amp;via=vitomd"
                onclick="window.open(this.href, 'twitter-share', 'width=550,height=235');return false;">
                Share it on Twitter
                </a>
              </p>
              </a>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body" style="padding-bottom:0; padding-top:10px">
        <div class="container has-text-centered">
          <div class="columns" style="height:400px">
            <div class="column is-5">
              <chessboard :playerColor="playerColor" :ai_difficulty="ai_difficulty" @onMove="showInfo" :key="chessboardId" @onEnd="onEnd" @onScore="showScore"/>
            </div>
            <div class="column is-7">
              <b-field position="is-centered">
                  <b-radio-button v-model="ai_difficulty"
                      native-value="Easy">
                      <span>Easy</span>
                  </b-radio-button>

                  <b-radio-button v-model="ai_difficulty"
                      native-value="Normal">
                      <span>Normal</span>
                  </b-radio-button>
                  
                  <b-radio-button v-model="ai_difficulty"
                      native-value="Hard">
                      <span>Hard</span>
                  </b-radio-button>
              </b-field>
              <div v-if="moreInfo" style="text-align:left" class="help">
                <p>
                  This is a fun chess variation. Two players plays together against someone, one say the piece name to move (BRAIN) and the other must move it (HAND). Still curious? Check some videos: <a href="https://www.youtube.com/watch?v=TL2pn1yIs2Y">Eric Hansen</a> or
                  <a href="https://www.youtube.com/watch?v=-dJgPFMJ0ao">Daniel Rensch</a> or <a href="https://www.youtube.com/watch?v=N-fSQAX4wkg">Anna Rudolf</a>
                </p>
                <p>
                  Here you will play against the computer. In each move the BRAIN (stockfish engine) will highlight the piece or pieces that are the best move and are the only pieces that you can move.
                  It is your job as the HAND to play the correct move.
                </p>
                <p>
                  There are 3 modes. Easy: stockfish depth 1, normal: stockfish depth 6, hard: stockfish depth 10.
                </p>
                <p>
                  I'm <a href="http://vitomd.com">@vitomd</a> a Software Engineer and chess lover. I made some other chess related projects:<br>
                  <a href="http://vitomd.com/vue-chess-guardian/">Chess Guardian</a>: Answer Chess positional questions from your own games. <br>
                  <a href="https://github.com/vitogit/vue-chessboard">Vue Chessboard Component</a>: Load positions, create positions and see threats.
                </p>
               
                <a @click.prevent="moreInfo=false" class="button">Keep playing</a>

              </div>
              <h1 v-if="!moreInfo" class="title">
               <div v-show="!endStyle" class ="shout" v-bind:class="[moveStyle]">{{moveMessage}}</div>
               <div v-show="!endStyle"class ="shout"  v-bind:class="[evalStyle]">{{evalMessage}}</div>
               <div v-show="tacticalOpportunity" class ="bright shout" >{{tacticalOpportunity}}</div>

               <div v-show="endStyle" class ="shout"  v-bind:class="[endStyle]">{{endText}}</div>
               <div>
                 <a @click.prevent="newGame('white')" class="button is-large">New Game as White</a><br>
                 <a @click.prevent="newGame('black')" class="button is-large">New Game as Black</a>
               </div>
               <div style="font-size:0.4em; padding:10px">
                 {{this.positionInfo}}
               </div>
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div class="hero-foot">
        <div class="container">
          <div v-if="!moreInfo" class="has-text-centered">
            Made by <a href="http://vitomd.com">@vitomd</a> with <a href="https://vuejs.org/">Vue.js</a> | Check all my <a href="http://vitomd.com/blog/projects/">chess related projects</a>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>

<style>
  #app {
    margin: 1vh;
  }
  .hero.is-fullheight {
    min-height: 95vh;
  }
  .cg-board-wrap {
    margin: 0 auto;
  }
</style>

<script>
import chessboard from './components/chessboard'
import './components/style/theme.css'

export default {
  name: 'app',
  components: {
    chessboard
  },
  data () {
    return {
      currentFen: '',
      positionInfo: null,
      moveMessage: "Move a highlighted piece.",
      evalMessage: "",
      firstMove: true,
      moveStyle: "",
      evalStyle: "",
      endStyle: "",
      endText: "",
      moreInfo: false,
      positionInfo: null,
      tacticalOpportunity: '',
      ai_difficulty: 'Normal',
      playerColor: 'white'
    }
  },
  methods: {
    onEnd(end) {
      this.endText = end
      if (end == "YOU WIN") {
        this.endStyle = "perfect"
      } else if (end == "YOU LOSE") {
        this.endStyle = "worst"
      } else {
        this.endStyle = "draw"
      }
    },
    showScore(scoreDiff, score) {
      if (this.firstMove) {
        this.firstMove = false
        return
      }

      if (scoreDiff > 400) {
        this.tacticalOpportunity = "Decisive Tactical Opportunity: "+scoreDiff
      } else if (scoreDiff > 200) {
        this.tacticalOpportunity = "Good Tactical Opportunity: "+scoreDiff
      } else if (scoreDiff > 100) {
        this.tacticalOpportunity = "Tactical Opportunity: "+scoreDiff
      } else {
        this.tacticalOpportunity = null
      }

      if (scoreDiff > -20 ) {
        this.moveMessage =  this.shuffle(this.evalText[6])
        this.moveStyle = 'perfect'
      } else if (scoreDiff > -50 ) {
        this.moveMessage =  this.shuffle(this.evalText[5])
        this.moveStyle = 'good'
      } else if (scoreDiff > -100 ) {
        this.moveMessage =  this.shuffle(this.evalText[4])
        this.moveStyle = 'equal'
      } else if (scoreDiff > -200 ) {
        this.moveMessage =  this.shuffle(this.evalText[3])
        this.moveStyle = 'bad'
      } else if (scoreDiff > -400 ) {
        this.moveMessage =  this.shuffle(this.evalText[2])
        this.moveStyle = 'bad'
      } else {
        this.moveMessage = this.shuffle(this.evalText[1])
        this.moveStyle = 'worst'
      }

      if (score > 900 ) {
        this.evalMessage = this.shuffle(this.scoreText[6])
        this.evalStyle = 'perfect'
      } else if (score > 400 ) {
        this.evalMessage = this.shuffle(this.scoreText[5])
        this.evalStyle = 'good'
      } else if (score > 100 ) {
        this.evalMessage = this.shuffle(this.scoreText[4])
        this.evalStyle = 'good'
      } else if (score > -100 ) {
        this.evalMessage = this.shuffle(this.scoreText[3])
        this.evalStyle = 'equal'
      } else if (score > -500 ) {
        this.evalMessage = this.shuffle(this.scoreText[2])
        this.evalStyle = 'bad'
      } else {
        this.evalMessage = this.shuffle(this.scoreText[1])
        this.evalStyle = 'worst'

      }
    },
    loadFen(fen) {
      this.currentFen = fen
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
      }
      return a[0];
    },
    newGame(color) {
      Object.assign(this.$data, this.$options.data());
      this.playerColor = color
      this.chessboardId++
    },
    showInfo(data) {
      this.positionInfo = data.pgn
    },
  },
  created() {
    this.chessboardId = 0

    this.fens = ['5rr1/3nqpk1/p3p2p/Pp1pP1pP/2pP1PN1/2P1Q3/2P3P1/R4RK1 b - f3 0 28',
                'r4rk1/pp1b3p/6p1/8/3NpP2/1P4P1/P2K3P/R6R w - - 0 22'
                ]
    this.evalText = {
      6:["Perfect move", "Excellent move", "Yeah. Perfect."],
      5:["Good move.", "That's right", "Well done"],
      4:["Meh", "A poor move", "You can do it better"],
      3:["Bad move", "You missed something"],
      2:["Blunder", "Really bad move", "Why?"],
      1:["Horrible move", "Big big blunder", "ouch!"],
    }

    this.scoreText = {
      6:["The victory is in your pocket ", "Go for it and finish it", "Go go go. You are going to win"],
      5:["Your position is excellent", "Winning easily", "Excellent play"],
      4:["You have the advantage", "The game is in your favor", "You are ahead"],
      3:["Equal game"],
      2:["Bad game", "You are losing", "The opponent has the advantage"],
      1:["Really bad game", "Almost finished", "You are going to lose soon"],
    }
  }
}
</script>

<style>
  #app {
    margin: 1vh;
  }
  .hero.is-fullheight {
    min-height: 95vh;
  }
  .cg-board-wrap {
    margin: 0 auto;
  }
  
  .perfect {
    background-color: #8bc34a;
    color: black;
    font-size: 1.5em;
  }

  .good {
    color: #8bc34a;
  }

  .bad {
    color: #f44336;
  }

  .worst {
    background-color: #f44336;
    color:black;
    font-size: 1.5em;
  }

  .shout {
    padding: 10px;
    border-radius: 10px;
    margin: 20px;
  }

  .bright {
    color: black;
    background-color: yellow;
  }
  .help p {
    margin: 5px 0;
    font-size: 1.4em;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue